interface MessageBubbleProps {
  speaker: string;
  message: string;
}

export function MessageBubble({ speaker, message }: MessageBubbleProps) {
  return (
    <div className="space-y-2">
      <p className="font-medium text-sm text-[#1a1817] font-weight-700">
        {speaker}:
      </p>
      <p className="text-gray-700 text-sm leading-relaxed">{message}</p>
    </div>
  );
}
